import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Briefcase18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4.59863 3.75H1.5C0.809644 3.75 0.25 4.30964 0.25 5V15.5C0.25 16.1904 0.809644 16.75 1.5 16.75H16.5C17.1904 16.75 17.75 16.1904 17.75 15.5V5C17.75 4.30964 17.1904 3.75 16.5 3.75H13.4014L11.7725 1.30662C11.5407 0.958876 11.1504 0.75 10.7324 0.75H7.26761C6.84966 0.75 6.45938 0.958876 6.22754 1.30662L4.59863 3.75ZM6.4014 3.75H11.5986L10.5986 2.25H7.4014L6.4014 3.75ZM9.75 11.7342V13H8.25V11.7335C6.00473 11.6367 3.79936 11.116 1.75 10.2006V15.25H16.25V10.202C14.2012 11.1188 11.9955 11.6392 9.75 11.7342ZM16.25 8.54316V5.25H1.75V8.54245C3.77704 9.55064 5.99078 10.1256 8.25 10.232V9H9.75V10.2327C12.0095 10.1284 14.2237 9.5533 16.25 8.54316Z'
      fill='currentColor'
    />
  </Svg>
);

Briefcase18.displayName = 'Briefcase18';
export default Briefcase18;
